var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    {
      staticClass: "collapsible-card",
      class: { "b-0 shadow-none": !_vm.cardStyle },
      attrs: { "no-body": "" },
    },
    [
      _c(
        "b-card-header",
        {
          directives: [
            {
              name: "b-toggle",
              rawName: "v-b-toggle",
              value: _vm.collapseId,
              expression: "collapseId",
            },
          ],
          staticClass: "card-header bb-0 flex-wrap no-border user-select-none",
          class: { "p-0": !_vm.cardStyle },
        },
        [
          _c("div", { staticClass: "d-flex justify-content-start" }, [
            _vm.showIndicator
              ? _c(
                  "div",
                  { staticClass: "d-flex align-items-center mr-2" },
                  [
                    _vm.visible
                      ? _c("icon", {
                          staticClass: "mt-2",
                          attrs: { name: "sort-up" },
                        })
                      : _c("icon", {
                          staticClass: "mb-2",
                          attrs: { name: "sort-desc" },
                        }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-center w-100",
              },
              [_vm._t("header", null, null, _vm.slotBindings)],
              2
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-collapse",
        {
          ref: _vm.collapseId,
          attrs: { id: _vm.collapseId },
          on: {
            shown: function ($event) {
              return _vm.$emit("shown")
            },
            hidden: function ($event) {
              return _vm.$emit("hidden")
            },
          },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c(
            "b-card-body",
            { staticClass: "pt-0", class: _vm.bodyClass },
            [_vm._t("body", null, null, _vm.slotBindings)],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }